<template>
  <nav :class="$style.navigation">
    <ul :class="[$style.navigation__link, $style.links]">
      <li :class="$style.links__item" v-for="(link, id) in links" :key="id">
        <RouterLink
          v-if="isInternalLinkType(link)"
          :class="$style.link"
          :active-class="$style['link--active']"
          :to="link.to"
          :exact="link.exact"
          @click="link.callback"
        >
          {{ link.text }}
        </RouterLink>
        <ExternalLink
          v-else-if="isExternalLinkType(link)"
          :class="$style.link"
          :href="link.href"
          @click="link.callback"
        >
          {{ link.text }}
        </ExternalLink>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
import { useNavigationLinks } from './useNavigationLinks'
import ExternalLink from '@/components/atoms/ExternalLink.vue'
import { isInternalLinkType, isExternalLinkType } from '@/libs/utilities/link'

const links = useNavigationLinks()
</script>

<style lang="scss" module>
.navigation {
  display: flex;
}

.links {
  display: flex;

  &__item {
    display: flex;

    &:nth-child(n + 2) {
      margin-left: 24px;
    }
  }
}

.link {
  display: flex;
  align-items: center;
  border-top: 3px solid transparent;
  border-bottom: 3px solid transparent;
  color: $color-text-and-object-medium-emphasis;
  font-weight: bold;
  transition: all $transition-interaction;

  &:hover {
    color: $color-text-and-object-accent-primary;
    text-decoration: none;
  }

  &--active {
    border-bottom: 3px solid $color-border-accent-primary;
    color: $color-text-and-object-accent-primary;

    &:hover {
      color: $color-text-and-object-accent-primary;
    }
  }
}
</style>
